/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import QuestionMark from '../../../../shared/QuestionMark';
import ErrorAtTop from '../ErrorAtTop';
import { FormattedHTMLMessage } from 'react-intl';
import './FormTitle.css'

class FormTitle extends React.Component {

  render() {
    const { content, errorAtTop } = this.props;
    return (
      <div className="form-title-row">
        {content.title &&
          <h1 className="form-title" data-key={content.title.dataKey}>
            {content.title.text}
          </h1>
        }

        {content.subTitle &&
          <div className="form-sub-title" data-key={content.subTitle.dataKey}>
            <FormattedHTMLMessage
              id={content.subTitle.dataKey}
              defaultMessage={content.subTitle.text}
            />
            {content.showHints &&
              <QuestionMark questionTitle={ content.subTitle }>
                <hints dataKey={content.showHints.dataKey}>{content.showHints.text}</hints>
              </QuestionMark>
            }
          </div>
        }
        <hr className="form-title-hr" aria-hidden={true} />
        { errorAtTop.isDisplay &&
            <ErrorAtTop 
                content={errorAtTop.content}
                isDisplay={errorAtTop.isDisplay}
            />
        }
        {
          content.optional_msg &&
          <div className="form-optional-msg" data-key={content.optional_msg.dataKey}>
            {content.optional_msg.text}
          </div>
        }
      </div>
    )
  }
}

FormTitle.propTypes = {
  content: PropTypes.object.isRequired,
  errorAtTop: PropTypes.object
};

FormTitle.defaultProps = {
  content: {},
  errorAtTop: {
    isDisplay: false
  }
};

export default FormTitle;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/FormTitle/index.js